function openPopup(badgeData) {
  document.body.insertAdjacentHTML('beforeend', getModalContent(badgeData));
  
  // Initialize read more functionality
  initializeReadMore();
  
  // Initialize set default button
  initializeSetDefaultButton();
  
  ["close-modal"].forEach(linkClass => {
    let links = document.querySelectorAll("." + linkClass);
    links.forEach(link => {
      link.addEventListener("click", () => {
        if (window.innerWidth < 768) {
          toggleModal(true, true);
        } else {
          toggleModal(false, true);
        }
      });
    });
  });

  if (window.innerWidth < 768) {
    toggleModal(true, false);
  } else {
    toggleModal(false, false);
  }
}

function toggleModal(isMobile, isOpen) {
  let badgeModal = document.getElementById("badge-modal");
  let badgeDrawer = document.getElementById("badge-drawer");
  let target = isMobile ? badgeDrawer : badgeModal;
  let options = isMobile ? {
    placement: 'bottom',
    backdrop: true,
    bodyScrolling: false,
    edge: false,
    edgeOffset: '',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30',
    onHide: () => {
      badgeDrawer.style.transform = "translateY(100%)";
        setTimeout(() => {
          badgeDrawer.style.display = "none";
          badgeDrawer.remove();
        }, 200);
    },
    onShow: () => {
        badgeDrawer.style.display = "block";
        badgeDrawer.style.transform = "translateY(0%)";
    },
    onToggle: () => {},
  } : {
    backdrop: 'dynamic',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
    closable: true,
    onHide: () => {
      badgeModal.remove();
    },
    onShow: () => {},
    onToggle: () => {},
  };
	let instanceOptions = {
	  id: isMobile ? 'badge-drawer' : 'badge-modal',
	  override: true
	};
	let instance = isMobile ? new Drawer(target, options, instanceOptions) : new Modal(target, options, instanceOptions);
  if (isOpen) {
    instance.hide();
  } else {
    instance.show();
  }
}


function getModalContent(badgeData) {
  const badgeName = badgeData?.name || 'Badge';
  const badgeDescription = badgeData?.description || 'Achievement unlocked!';
  const badgeIcon = badgeData?.icon || 'https://cdnyc3.pepper.ru/static/badge/automated/Hotspot-Level3.png';
  const isUnlocked = badgeData?.unlocked === 'true';
  const userCount = badgeData?.userCount || 0;
  
  const content = `
    <div class="flex justify-center items-center flex-col relative overflow-hidden">
      <button type="button" class="close-modal absolute top-1 right-1 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white z-20">
        <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
        </svg>
      </button>
      
      <div class="z-[1] mt-[20px] font-bold text-primary-text-light dark:text-primary-text-dark text-3xl text-center break-words leading-tight pr-8">${badgeName}</div>
      
      <div class="z-[1] text-primary-text-light dark:text-primary-text-dark mb-4 text-base text-center break-words leading-relaxed max-w-sm">
        <div id="badge-description-container">
          <span id="badge-description" class="line-clamp-3">${badgeDescription}</span>
          <button id="read-more-btn" class="text-primary hover:underline text-sm ml-1 hidden">...${I18n.t('read_more')}</button>
        </div>
      </div>
      
      <div class="relative inline-block mb-6 mt-4">
        <img src="${badgeIcon}" width="145px" height="145px" class="relative z-[1]" style="filter: ${!isUnlocked ? 'grayscale(1)' : 'none'};" />
        
        ${isUnlocked ? `<!-- Lottie Animation - Top Right of Badge Image -->
        <dotlottie-player 
          src="https://lottie.host/e2bacfbb-ca1d-4e8f-87b9-3d858ab2f3b6/4R9dWYsTO1.lottie" 
          background="transparent" 
          speed="1" 
          style="width: 150px; height: 150px; position: absolute; top: -30px; right: -30px; z-index: 16; pointer-events: none;" 
          loop 
          autoplay>
        </dotlottie-player>` : ''}
      </div>
      
      <div class="z-[1] font-bold text-primary-text-light text-center dark:text-primary-text-dark text-3xl">
        <svg width="50" height="50" height="50" viewBox="0 0 24 24" class="align-text-bottom mr-1 block" aria-hidden="true">
          <path d="M2.29,16.43v-1.03c.02-.59.35-1.12.88-1.38.7-.39,1.49-.58,2.29-.54.16,0,.31,0,.47.01.16,0,.32.03.48.06-.16.25-.28.53-.37.82-.08.28-.12.58-.12.87v1.19h-3.64ZM7.35,16.43v-1.16c0-.39.11-.77.33-1.08.25-.35.58-.65.96-.86.46-.26.96-.45,1.48-.55.61-.13,1.24-.19,1.87-.18.63,0,1.27.06,1.89.18.52.1,1.02.29,1.48.55.38.21.71.5.96.86.22.32.33.7.33,1.08v1.16H7.35ZM18.07,16.43v-1.19c0-.3-.04-.6-.11-.9-.07-.28-.19-.55-.34-.8.16-.03.32-.05.47-.06.15,0,.3-.01.45-.01.8-.04,1.59.15,2.29.54.53.27.87.8.88,1.39v1.03h-3.64ZM5.46,12.65c-.38,0-.75-.15-1.02-.42-.28-.27-.43-.64-.42-1.02,0-.38.15-.75.42-1.02.27-.27.64-.42,1.02-.42.38,0,.75.14,1.02.42.28.27.43.64.42,1.02,0,.38-.15.75-.42,1.02-.27.28-.64.44-1.03.43ZM18.55,12.65c-.38,0-.75-.15-1.02-.43-.28-.27-.43-.63-.43-1.02,0-.39.15-.76.43-1.02.27-.27.64-.42,1.02-.42.39,0,.76.14,1.03.42.27.27.42.64.42,1.02,0,.38-.14.75-.42,1.02-.27.28-.64.43-1.03.42ZM12,11.96c-.58.01-1.15-.22-1.55-.64-.42-.41-.65-.97-.64-1.55-.01-.59.22-1.15.64-1.56.41-.41.97-.64,1.55-.63.59-.01,1.15.21,1.56.63.42.41.64.97.63,1.56.01.58-.22,1.14-.63,1.55-.41.42-.97.66-1.56.64Z" transform="translate(1, 1)" fill="currentColor"/>
        </svg>
        <span>${userCount.toLocaleString()}</span>
      </div>
      <div class="z-[1] text-primary-text-light dark:text-primary-text-dark text-sm mb-4">${I18n.t('users_earned_this_badge')}</div>
      
      ${getSetDefaultButton(badgeData)}
      
      <div class="z-[0] rounded-tr-[50%] rounded-tl-[50%] absolute w-[140%] h-full bg-[#FE6301] opacity-[.1] top-[50%] left-1/2 -translate-x-1/2 pointer-events-none"></div>
    </div>
  `;

  if (window.innerWidth < 768) {
    return `<div id="badge-drawer" style="display:none" class="overflow-hidden fixed bottom-0 left-0 right-0 z-40 w-full rounded-t-[20px] overflow-y-auto bg-white dark:bg-background-dark translate-y-[100%] transition-transform" tabindex="-1" aria-labelledby="drawer-bottom-label">
        ${content}
      </div>`;
  } else {
    return `<div id="badge-modal" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
      <div class="relative w-full max-w-md max-h-full">
          <div class="common-box relative shadow md:w-[450px] w-[95%] mx-auto overflow-hidden">
            ${content}
          </div>
      </div>
    </div>`
  }
}

function getSetDefaultButton(badgeData) {
  const isUnlocked = badgeData?.unlocked === 'true';
  const badgeId = badgeData?.id;
  const badgeIcon = badgeData?.icon;
  
  if (!isUnlocked) return '';
  
  // Only show selection button if user can select badges (viewing own profile)
  if (!window.canSelectBadges) return '';
  
  const isCurrentDefault = window.currentSelectedBadgeId?.toString() === badgeId;
  
  if (isCurrentDefault) {
    return `<div class="z-[1] bg-transparent text-primary border border-primary rounded-bradius10 w-max py-2 px-3 mb-[20px] text-sm whitespace-nowrap cursor-not-allowed">${I18n.t('selected_badge')}</div>`;
  }
  
  return `<div class="z-[1] make-default cursor-pointer select-badge bg-primary w-max mb-[20px] text-white py-2 px-3 rounded-md text-sm whitespace-nowrap" 
           data-id="badge_selection_${badgeId}" 
           data-badge-id="${badgeId}" 
           data-badge-url="${badgeIcon}">
    ${I18n.t('make_as_default')}
  </div>`;
}

// Optimized: Green tick functionality
function addSelectedBadgeTick(badgeId) {
  document.querySelectorAll('.selected-badge-tick').forEach(tick => tick.remove());
  
  // Only show green tick if user can select badges (viewing own profile)
  if (!window.canSelectBadges) return;
  
  const badgeElement = document.querySelector(`[data-badge-id="${badgeId}"]`);
  if (!badgeElement) return;
  
  const tick = document.createElement('div');
  tick.className = 'selected-badge-tick absolute top-[5px] md:right-[45px] right-[30px] w-6 h-6 bg-green-500 rounded-full flex items-center justify-center z-10';
  tick.innerHTML = `<svg class="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
    <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
  </svg>`;
  
  if (getComputedStyle(badgeElement).position === 'static') {
    badgeElement.style.position = 'relative';
  }
  
  badgeElement.appendChild(tick);
}

// Set default button - uses event delegation to avoid listener cleanup issues
function initializeSetDefaultButton() {
  // No-op: delegation handles all .select-badge clicks
}

// Handles .select-badge click via delegation
async function handleSelectBadgeClick(btn) {
  if (btn.dataset.processing === 'true') return;
  btn.dataset.processing = 'true';
  
  const badgeId = btn.getAttribute('data-badge-id');
  const radioBtnId = btn.getAttribute('data-id');
  const badgeUrl = btn.getAttribute('data-badge-url');
  
  const originalText = btn.textContent;
  btn.textContent = 'Setting...';
  btn.style.pointerEvents = 'none';
  
  try {
    if (typeof userSelectionStore === 'function') {
      userSelectionStore(badgeId, null, radioBtnId, badgeUrl);
      handleSelectBadgeSuccess(btn, badgeId);
    } else {
      document.querySelectorAll('.badges_ranks_loader_container').forEach(loader => {
        loader.style.display = 'block';
      });
      
      const response = await fetch(`/profile/badge_selection?${new URLSearchParams({
        badge_id: badgeId,
        reputation_level_id: null,
        radio_id: radioBtnId,
        badge_url: badgeUrl
      })}`, {
        method: 'GET',
        headers: { 
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          handleSelectBadgeSuccess(btn, badgeId);
        } else {
          console.error('Badge selection failed:', result.message);
          handleSelectBadgeError(btn, originalText);
        }
      } else {
        console.error('Badge selection failed:', response.status, response.statusText);
        handleSelectBadgeError(btn, originalText);
      }
    }
  } catch (error) {
    console.error('Error setting badge as default:', error);
    handleSelectBadgeError(btn, originalText);
  }
}

function handleSelectBadgeSuccess(btn, badgeId) {
  document.querySelectorAll('.badges_ranks_loader_container').forEach(loader => {
    loader.style.display = 'none';
  });
  
  window.currentSelectedBadgeId = parseInt(badgeId);
  btn.style.display = 'none';
  btn.dataset.processing = 'false';
  
  if (window.innerWidth < 768) {
    toggleModal(true, true);
  } else {
    toggleModal(false, true);
  }
  
  addSelectedBadgeTick(badgeId);
}

function handleSelectBadgeError(btn, originalText) {
  document.querySelectorAll('.badges_ranks_loader_container').forEach(loader => {
    loader.style.display = 'none';
  });
  
  btn.textContent = originalText;
  btn.style.pointerEvents = 'auto';
  btn.dataset.processing = 'false';
}

function initializeReadMore() {
  const containerEl = document.getElementById('badge-description-container');
  const descriptionEl = document.getElementById('badge-description');
  const readMoreBtn = document.getElementById('read-more-btn');
  
  if (!containerEl || !descriptionEl || !readMoreBtn) return;
  
  const originalText = descriptionEl.textContent;
  
  setTimeout(() => {
    const lineHeight = parseInt(window.getComputedStyle(descriptionEl).lineHeight);
    const maxHeight = lineHeight * 3;
    
    if (descriptionEl.scrollHeight > maxHeight) {
      readMoreBtn.classList.remove('hidden');
      
      let isExpanded = false;
      readMoreBtn.addEventListener('click', () => {
        if (isExpanded) {
          descriptionEl.className = 'line-clamp-3';
          descriptionEl.textContent = originalText;
          readMoreBtn.textContent = '...' + I18n.t('read_more');
          readMoreBtn.classList.remove('hidden');
        } else {
          descriptionEl.className = '';
          descriptionEl.innerHTML = originalText + ' <button class="text-primary hover:underline text-sm ml-1" onclick="this.parentElement.parentElement.querySelector(\'#read-more-btn\').click()">' + I18n.t('less') + '</button>';
          readMoreBtn.classList.add('hidden');
        }
        isExpanded = !isExpanded;
      });
    }
  }, 100);
}

// Main initialization - uses event delegation for dynamic elements
function setBadgePopup() {
  // Single delegated listener for .select-badge (handles popup + page-level buttons)
  if (!window._badgeSelectDelegated) {
    window._badgeSelectDelegated = true;
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.select-badge');
      if (btn) {
        e.preventDefault();
        handleSelectBadgeClick(btn);
      }
    });
  }
  
  // Single delegated listener for .badge-open-popup
  if (!window._badgePopupDelegated) {
    window._badgePopupDelegated = true;
    document.addEventListener('click', (e) => {
      const element = e.target.closest('.badge-open-popup');
      if (element) {
        const badgeData = {
          id: element.dataset.badgeId,
          name: element.dataset.badgeName,
          description: element.dataset.badgeDescription,
          icon: element.dataset.badgeIcon,
          count: element.dataset.badgeCount,
          unlocked: element.dataset.badgeUnlocked,
          unlockDate: element.dataset.badgeUnlockDate,
          userCount: element.dataset.badgeUserCount,
          category: element.dataset.badgeCategory,
          recordType: element.dataset.badgeRecordType
        };
        openPopup(badgeData);
      }
    });
  }
  
  setTimeout(() => {
    if (window.currentSelectedBadgeId) {
      addSelectedBadgeTick(window.currentSelectedBadgeId);
    }
  }, 1000);
}

// Global userSelectionStore function for compatibility
function userSelectionStore(badge_id, reputation_level_id, radio_btn_id, badge_url) {
  document.querySelectorAll('.badges_ranks_loader_container').forEach(loader => {
    loader.style.display = 'block';
  });
  fetchAPI('/profile/badge_selection', 'GET', {
    badge_id,
    reputation_level_id,
    radio_id: radio_btn_id,
    badge_url
  }, 'script');
}

// Make functions globally available
window.setBadgePopup = setBadgePopup;
window.userSelectionStore = userSelectionStore;

export { setBadgePopup };